// ** React Imports
import { Fragment } from "react";
import { CustomSearchPagination } from "@store/action/GlobalAction";
import PlaylistCards from "./PlaylistCards";
import PlaylistHeader from "./PlaylistHeader";

const Playlist = (props) => {
  const {
    activeView,
    setActiveView,
    currentPage,
    setCurrentPage,
    getAllPlaylists,
    bycategory,
    dispatch,
    radio_id,
    store,
    t,
  } = props;
  const handlePageChange = (x) => {
    setCurrentPage(x.selected + 1);
    dispatch(
      getAllPlaylists({
        page: x.selected + 1,
        per_page: 5,
        search: window.location.search,
      })
    );
  };

  return (
    <div>
      <PlaylistHeader activeView={activeView} setActiveView={setActiveView} />
      {store?.data?.length || store?.dataBycategory?.length ? (
        <Fragment>
          <PlaylistCards
            activeView={activeView}
            bycategory={bycategory}
            datas={store}
          />
          <div className="d-flex justify-content-center">
            {CustomSearchPagination(
              store.total,
              5,
              currentPage,
              handlePageChange
            )}
          </div>
        </Fragment>
      ) : (
        <div className="d-flex justify-content-center mt-2">
          <p>{t("No Results")}</p>
        </div>
      )}
    </div>
  );
};

export default Playlist;
